import {
  CHECKLIST_TEMPLATE_LIST_ACTIVE,
  CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS,
  CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS,
  CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE,
  CHECKLIST_SEARCH,
  CHECKLIST_SEARCH_SUCCESS,
  CHECKLIST_SEARCH_FAILURE,
  CHECKLIST_DATA,
  CHECKLIST_DATA_SUCCESS,
  CHECKLIST_DATA_FAILURE,
  CHECKLIST_UPDATE,
  CHECKLIST_UPDATE_SUCCESS,
  CHECKLIST_UPDATE_FAILURE,
  CHECKLIST_PDF_SHEET,
  CHECKLIST_PDF_SHEET_SUCCESS,
  CHECKLIST_PDF_SHEET_FAILURE,
  DELETE_TASK_CHECKLIST,
  DELETE_TASK_CHECKLIST_SUCCESS,
  DELETE_TASK_CHECKLIST_FAILURE,
  CHECKLIST_MERGE_WITH_TEMPLATE,
  CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS,
  CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE,
  TASK_CHECKLIST_SEARCH,
  TASK_CHECKLIST_SEARCH_SUCCESS,
  TASK_CHECKLIST_SEARCH_FAILURE,
  TASK_CHECKLIST_LIST,
  TASK_CHECKLIST_LIST_SUCCESS,
  TASK_CHECKLIST_LIST_FAILURE,
  CHECKLIST_PDF_SHEET_DEBUG,
  CHECKLIST_PDF_SHEET_DEBUG_SUCCESS,
  CHECKLIST_PDF_SHEET_DEBUG_FAILURE,
  CREATE_CHECKLIST_TEMPLATE,
  CREATE_CHECKLIST_TEMPLATE_SUCCESS,
  CREATE_CHECKLIST_TEMPLATE_FAILURE,
  UPDATE_CHECKLIST_TEMPLATE,
  UPDATE_CHECKLIST_TEMPLATE_SUCCESS,
  UPDATE_CHECKLIST_TEMPLATE_FAILURE,
  CLONE_CHECKLIST_TEMPLATE,
  CLONE_CHECKLIST_TEMPLATE_SUCCESS,
  CLONE_CHECKLIST_TEMPLATE_FAILURE,
  CHECKLIST_TEMPLATE_DATATYPE_LIST,
  CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS,
  CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE,
} from "./actionType";

const initial = {
  checklistTemplateActive: [],
  checklistTemplateLoading: false,
  checklistTemplateError: null,

  checklistTemplateAssign: [],
  checklistTemplateAssignLoading: false,
  checklistTemplateAssignError: null,

  checklistSearch: [],
  checklistSearchLoading: false,
  checklistSearchError: null,

  checklistData: [],
  checklistDataLoading: false,
  checklistDataError: null,

  checklistUpdate: [],
  checklistUpdateLoading: false,
  checklistUpdateError: null,

  checklistPdfSheet: [],
  checklistPdfSheetLoading: false,
  checklistPdfSheetError: null,

  deleteTaskChecklist: [],
  deleteTaskChecklistLoading: false,
  deleteTaskChecklistError: null,

  checklistMergeWithTemplate: [],
  checklistMergeWithTemplateLoading: false,
  checklistMergeWithTemplateError: null,

  taskChecklistSearch: [],
  taskChecklistSearchLoading: false,
  taskChecklistSearchError: null,

  taskChecklistList: [],
  taskChecklistListLoading: false,
  taskChecklistListError: null,

  checklistPdfSheetDebug: [],
  checklistPdfSheetDebugLoading: false,
  checklistPdfSheetDebugError: null,

  createChecklistTemplate: [],
  createChecklistTemplateLoading: false,
  createChecklistTemplateError: null,

  updateChecklistTemplate: [],
  updateChecklistTemplateLoading: false,
  updateChecklistTemplateError: null,

  cloneChecklistTemplate: [],
  cloneChecklistTemplateLoading: false,
  cloneChecklistTemplateError: null,

  checklistTemplateDataTypeList: [],
  checklistTemplateDataTypeListLoading: false,
  checklistTemplateDataTypeListError: null,

  checklistTemplateSystemFieldList: [],
  checklistTemplateSystemFieldListLoading: false,
  checklistTemplateSystemFieldListError: null,

  checklistTemplatePdfThemeList: [],
  checklistTemplatePdfThemeListLoading: false,
  checklistTemplatePdfThemeListError: null,
};

const Checklist = (state = initial, action) => {
  switch (action.type) {
    case CHECKLIST_TEMPLATE_LIST_ACTIVE:
      return {
        ...state,
        checklistTemplateLoading: true,
        checklistTemplateError: null,
      };
    case CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS:
      return {
        ...state,
        checklistTemplateLoading: false,
        checklistTemplateActive: action.payload,
      };
    case CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE:
      return {
        ...state,
        checklistTemplateLoading: false,
        checklistTemplateError: action.payload,
      };

    case CHECKLIST_TEMPLATE_ASSIGN_TO_TASK:
      return {
        ...state,
        checklistTemplateAssignLoading: true,
        checklistTemplateAssignError: null,
      };
    case CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS:
      return {
        ...state,
        checklistTemplateAssignLoading: false,
        checklistTemplateAssign: action.payload,
      };
    case CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE:
      return {
        ...state,
        checklistTemplateAssignLoading: false,
        checklistTemplateAssignError: action.payload,
      };

    case CHECKLIST_SEARCH:
      return {
        ...state,
        checklistSearchLoading: true,
        checklistSearchError: null,
      };
    case CHECKLIST_SEARCH_SUCCESS:
      return {
        ...state,
        checklistSearchLoading: false,
        checklistSearch: action.payload,
      };
    case CHECKLIST_SEARCH_FAILURE:
      return {
        ...state,
        checklistSearchLoading: false,
        checklistSearchError: action.payload,
      };

    case CHECKLIST_DATA:
      return {
        ...state,
        checklistDataLoading: true,
        checklistDataError: null,
      };
    case CHECKLIST_DATA_SUCCESS:
      return {
        ...state,
        checklistDataLoading: false,
        checklistData: action.payload,
      };
    case CHECKLIST_DATA_FAILURE:
      return {
        ...state,
        checklistDataLoading: false,
        checklistDataError: action.payload,
      };

    case CHECKLIST_UPDATE:
      return {
        ...state,
        checklistUpdateLoading: true,
        checklistUpdateError: null,
      };
    case CHECKLIST_UPDATE_SUCCESS:
      return {
        ...state,
        checklistUpdateLoading: false,
        checklistUpdate: action.payload,
      };
    case CHECKLIST_UPDATE_FAILURE:
      return {
        ...state,
        checklistUpdateLoading: false,
        checklistUpdateError: action.payload,
      };
    case CHECKLIST_PDF_SHEET:
      return {
        ...state,
        checklistPdfSheetLoading: true,
        checklistPdfSheetError: null,
      };
    case CHECKLIST_PDF_SHEET_SUCCESS:
      return {
        ...state,
        checklistPdfSheetLoading: false,
        checklistPdfSheet: action.payload,
      };
    case CHECKLIST_PDF_SHEET_FAILURE:
      return {
        ...state,
        checklistPdfSheetLoading: false,
        checklistPdfSheetError: action.payload,
      };
    case DELETE_TASK_CHECKLIST:
      return {
        ...state,
        deleteTaskChecklistLoading: true,
        deleteTaskChecklistError: null,
      };
    case DELETE_TASK_CHECKLIST_SUCCESS:
      return {
        ...state,
        deleteTaskChecklistLoading: false,
        deleteTaskChecklist: action.payload,
      };
    case DELETE_TASK_CHECKLIST_FAILURE:
      return {
        ...state,
        deleteTaskChecklistLoading: false,
        deleteTaskChecklistError: action.payload,
      };
    case CHECKLIST_MERGE_WITH_TEMPLATE:
      return {
        ...state,
        checklistMergeWithTemplateLoading: true,
        checklistMergeWithTemplateError: null,
      };
    case CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS:
      return {
        ...state,
        checklistMergeWithTemplateLoading: false,
        checklistMergeWithTemplate: action.payload,
      };
    case CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE:
      return {
        ...state,
        checklistMergeWithTemplateLoading: false,
        checklistMergeWithTemplateError: action.payload,
      };
    case TASK_CHECKLIST_SEARCH:
      return {
        ...state,
        taskChecklistSearchLoading: true,
        taskChecklistSearchError: null,
      };
    case TASK_CHECKLIST_SEARCH_SUCCESS:
      return {
        ...state,
        taskChecklistSearchLoading: false,
        taskChecklistSearch: action.payload,
      };
    case TASK_CHECKLIST_SEARCH_FAILURE:
      return {
        ...state,
        taskChecklistSearchLoading: false,
        taskChecklistSearchError: action.payload,
      };
    case TASK_CHECKLIST_LIST:
      return {
        ...state,
        taskChecklistListLoading: true,
        taskChecklistListError: null,
      };
    case TASK_CHECKLIST_LIST_SUCCESS:
      return {
        ...state,
        taskChecklistListLoading: false,
        taskChecklistList: action.payload,
      };
    case TASK_CHECKLIST_LIST_FAILURE:
      return {
        ...state,
        taskChecklistListLoading: false,
        taskChecklistListError: action.payload,
      };
    case CHECKLIST_PDF_SHEET_DEBUG:
      return {
        ...state,
        checklistPdfSheetDebugLoading: true,
        checklistPdfSheetDebugError: null,
      };
    case CHECKLIST_PDF_SHEET_DEBUG_SUCCESS:
      return {
        ...state,
        checklistPdfSheetDebugLoading: false,
        checklistPdfSheetDebug: action.payload,
      };
    case CHECKLIST_PDF_SHEET_DEBUG_FAILURE:
      return {
        ...state,
        checklistPdfSheetDebugLoading: false,
        checklistPdfSheetDebugError: action.payload,
      };

    case CREATE_CHECKLIST_TEMPLATE:
      return {
        ...state,
        createChecklistTemplateLoading: true,
        createChecklistTemplateError: null,
      };
    case CREATE_CHECKLIST_TEMPLATE_SUCCESS:
      return {
        ...state,
        createChecklistTemplateLoading: false,
        createChecklistTemplate: action.payload,
      };
    case CREATE_CHECKLIST_TEMPLATE_FAILURE:
      return {
        ...state,
        createChecklistTemplateLoading: false,
        createChecklistTemplateError: action.payload,
      };

    case UPDATE_CHECKLIST_TEMPLATE:
      return {
        ...state,
        updateChecklistTemplateLoading: true,
        updateChecklistTemplateError: null,
      };
    case UPDATE_CHECKLIST_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateChecklistTemplateLoading: false,
        updateChecklistTemplate: action.payload,
      };
    case UPDATE_CHECKLIST_TEMPLATE_FAILURE:
      return {
        ...state,
        updateChecklistTemplateLoading: false,
        updateChecklistTemplateError: action.payload,
      };

    case CLONE_CHECKLIST_TEMPLATE:
      return {
        ...state,
        cloneChecklistTemplateLoading: true,
        cloneChecklistTemplateError: null,
      };
    case CLONE_CHECKLIST_TEMPLATE_SUCCESS:
      return {
        ...state,
        cloneChecklistTemplateLoading: false,
        cloneChecklistTemplate: action.payload,
      };
    case CLONE_CHECKLIST_TEMPLATE_FAILURE:
      return {
        ...state,
        cloneChecklistTemplateLoading: false,
        cloneChecklistTemplateError: action.payload,
      };

    case CHECKLIST_TEMPLATE_DATATYPE_LIST:
      return {
        ...state,
        checklistTemplateDataTypeListLoading: true,
        checklistTemplateDataTypeListError: null,
      };
    case CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS:
      return {
        ...state,
        checklistTemplateDataTypeListLoading: false,
        checklistTemplateDataTypeList: action.payload,
      };
    case CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE:
      return {
        ...state,
        checklistTemplateDataTypeListLoading: false,
        checklistTemplateDataTypeListError: action.payload,
      };

    case CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST:
      return {
        ...state,
        checklistTemplateSystemFieldListLoading: true,
        checklistTemplateSystemFieldListError: null,
      };
    case CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS:
      return {
        ...state,
        checklistTemplateSystemFieldListLoading: false,
        checklistTemplateSystemFieldList: action.payload,
      };
    case CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE:
      return {
        ...state,
        checklistTemplateSystemFieldListLoading: false,
        checklistTemplateSystemFieldListError: action.payload,
      };

    case CHECKLIST_TEMPLATE_PDFTHEME_LIST:
      return {
        ...state,
        checklistTemplatePdfThemeListLoading: true,
        checklistTemplatePdfThemeListError: null,
      };
    case CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS:
      return {
        ...state,
        checklistTemplatePdfThemeListLoading: false,
        checklistTemplatePdfThemeList: action.payload,
      };
    case CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE:
      return {
        ...state,
        checklistTemplatePdfThemeListLoading: false,
        checklistTemplatePdfThemeListError: action.payload,
      };

    default:
      return state;
  }
};

export default Checklist;
